<template>
  <div>
    <van-popup v-model="detailModel"
               position="bottom"
               :style="{ height: '100%',background: '#f5f5f5' }">
      <van-nav-bar fixed>
        <div slot="title">审批明细</div>
        <div slot="right"
             @click="closeCur">关闭</div>
      </van-nav-bar>
      <div class="detail-con">
        <van-cell-group>
          <van-cell title="课程名称"
                    v-model="detail.DeclareSujectName" />
          <van-cell title="申报时间"
                    v-model="detail.CreateByDate" />
          <van-cell title="课程描述"
                    v-model="detail.DeclareSujectDescribe" />
          <van-cell title="审批状态"
                    v-if="detail.DeclareState !== 1"
                    v-model="detail.DeclareStateName" />
          <div v-if="detail.DeclareState === 1">
            <div class="approval">
              <span class="left">审批</span>
              <van-radio-group v-model="approvalStatus"
                               @change="approval">
                <van-radio name="pass">通过</van-radio>
                <van-radio name="refuse">拒绝</van-radio>
              </van-radio-group>
            </div>
            <!-- 拒绝原因 -->
            <van-field v-show="approvalStatus === 'refuse'"
                       v-model="rowRefuse.reason"
                       name="reason"
                       label="拒绝原因"
                       v-validate="'required'"
                       data-vv-scope="valiRefuse"
                       data-vv-as="拒绝原因"
                       :error-message="errors.first('valiRefuse.reason')"
                       required
                       type="textarea"
                       maxlength="200"
                       label-width="70px"
                       placeholder="请输入拒绝原因" />
            <!-- 通过-选学科 -->
            <van-field v-show="approvalStatus === 'pass'"
                       v-model="row.courseName"
                       name="courseName"
                       label="学科"
                       v-validate="'required'"
                       data-vv-scope="valiPass"
                       data-vv-as="学科"
                       :error-message="errors.first('valiPass.courseName')"
                       required
                       readonly
                       is-link
                       @click="showCourse = true"
                       label-width="70px"
                       placeholder="请选择学科" />
            <!-- 通过-选校本 -->
            <van-field v-show="approvalStatus === 'pass'"
                       v-model="row.categoryName"
                       name="categoryName"
                       label="校本分类"
                       v-validate="'required'"
                       data-vv-scope="valiPass"
                       data-vv-as="校本分类"
                       :error-message="errors.first('valiPass.categoryName')"
                       required
                       readonly
                       is-link
                       @click="showCategory = true"
                       label-width="70px"
                       placeholder="请选择校本分类" />
            <!-- 审批按钮 -->
            <div class="two-bottom-btn">
              <van-button round
                          type="default"
                          class="cancel"
                          @click="closeCur">取消</van-button>
              <van-button round
                          type="info"
                          class="submit"
                          @click="submitClick"
                          :loading="loading"
                          loading-text="保存中...">确认</van-button>
            </div>
          </div>
        </van-cell-group>
        <!-- 选择学科 -->
        <van-action-sheet v-model="showCourse"
                          :actions="courseList"
                          @select="selectCourse"
                          cancel-text="取消"
                          close-on-click-action />
        <!-- 选择校本 -->
        <van-action-sheet v-model="showCategory"
                          :actions="categoryList"
                          @select="selectCategory"
                          cancel-text="取消"
                          close-on-click-action />
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    detailModel: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  name: "DeclareApplyDetail",
  components: {},
  data () {
    return {
      showCourse: false,
      showCategory: false,
      courseList: [], //学科
      categoryList: [], //校本分类
      row: {
        courseId: -1,
        courseName: "",
        categoryId: -1,
        categoryName: ""
      },
      rowRefuse: {
        reason: ""
      },
      approvalStatus: "pass",
      loading: false
    };
  },
  created () { },
  mounted () {
    this.getCourse();
    this.getCategory();
  },
  methods: {
    //学科
    async getCourse () {
      let res = await this.xyapi.get(
        `${this.xyMApi}/api/Discipline/GetAllDiscipline`
      );
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            this.courseList.push({
              name: item.DisciplineName,
              id: item.DisciplineID
            });
          });
        }
      }
    },
    //校本分类
    async getCategory () {
      let res = await this.xyapi.get(
        `${this.xyMApi}/api/SubjectCategory/GetAll`
      );
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            this.categoryList.push({
              name: item.SubjectCategoryName,
              id: item.SubjectCategoryID
            });
          });
        }
      }
    },
    //选择学科
    selectCourse (val) {
      this.row.courseName = val.name;
      this.row.courseId = val.id;
    },
    //选择校本
    selectCategory (val) {
      this.row.categoryName = val.name;
      this.row.categoryId = val.id;
    },
    //选择通过或拒绝
    approval (val) {
      this.approvalStatus = val;
    },
    //取消、关闭当前弹框
    closeCur () {
      this.$emit("closeDetail");
    },
    //确认
    submitClick () {
      this.$validator
        .validateAll(this.approvalStatus === "pass" ? "valiPass" : "valiRefuse")
        .then(res => {
          if (!res) {
            this.loading = false;
          } else {
            this.loading = true;
            this.xy.loading("保存中");
            if (this.approvalStatus === "pass") {
              this.okPass();
            } else if (this.approvalStatus === "refuse") {
              this.okRefuse();
            }
          }
        });
    },
    async okPass () {
      this.xy.loading();
      let res = await this.xyapi.post(
        `${this.$store.state.apiPath}/api/Declare/Adopt`,
        {
          DeclareID: this.detail.DeclareID,
          DeclareSujectName: this.detail.DeclareSujectName,
          DisciplineID: this.row.courseId,
          SubjectCategoryID: this.row.categoryId
        }
      );
      this.xy.unloading();
      this.loading = false;
      if (res.success) {
        this.xy.msgSuc("审批成功");
        this.$emit("closeDetail");
      }
    },
    async okRefuse () {
      this.xy.loading();
      let res = await this.xyapi.post(
        `${this.$store.state.apiPath}/api/Declare/Refuse?declareID=${this.detail.DeclareID}&approveOpinion=${this.rowRefuse.reason}`
      );
      this.xy.unloading();
      this.loading = false;
      if (res.success) {
        this.xy.msgSuc("审批成功");
        this.$emit("closeDetail");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.detail-con {
  margin-top: 110px;
}
.van-cell-group {
  margin-top: 20px;
  background: #f9f9f9;
  .van-cell {
    margin-bottom: 15px;
    .van-cell__value {
      color: #666;
    }
  }
}
.two-bottom-btn {
  height: 110px;
  line-height: 110px;
  background: #000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 70px;
  display: flex;
  align-items: center;
  .cancel {
    flex: 1;
    height: 76px;
    line-height: 76px;
  }
  .submit {
    flex: 1;
    height: 76px;
    line-height: 76px;
    margin-left: 40px;
  }
}
.approval {
  display: flex;
  height: 88px;
  background: #fff;
  padding: 20px 32px;
  font-size: 28px;
  margin-bottom: 20px;
  .left {
    display: flex;
    align-items: center;
  }
  .van-radio-group {
    display: flex;
    margin-left: 65px;
    > div {
      margin-left: 20px;
    }
  }
}
</style>
